var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:{ photo: true, zoom: _vm.zoom },attrs:{"alt":'Photo de ' + _vm.pseudo,"src":_vm.src,"draggable":"false","unSelectable":""},on:{"contextmenu":_vm.context}})
}
var staticRenderFns = []

export { render, staticRenderFns }